import { render, staticRenderFns } from "./thamDinhVanBan.vue?vue&type=template&id=5b74e67c&scoped=true&"
import script from "./thamDinhVanBan.vue?vue&type=script&lang=js&"
export * from "./thamDinhVanBan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b74e67c",
  null
  
)

export default component.exports